import styled, { css } from 'styled-components';
import { colors, fonts } from 'stylesheets';
import searchIcon from 'assets/img/icons/search.svg';

export const Search = styled.div`
  position: relative;

  ${({ collapsed, width }) => (collapsed
    ? `
  display: flex;
  justify-content: flex-end;
  flex: 1;
    `
    : `
  width: ${width || '277px'};
    `
  )}
`;

export const Input = styled.input`
  transition: all 0.3s ease;
  
  height: ${({ height }) => height || '40px'};
  border-radius: 4px;
  padding-left: 10px;
  padding-right: 10px;
  font: 12px 'Roboto',sans-serif;
  background: url(${searchIcon}) no-repeat scroll;
  background-position: 95%;
  background-color: ${colors.white};

  ${({ collapsed, width }) => (collapsed
    ? `
  border: 0px solid #cbcbcb;
  width: 20px;
  background-size: 20px 20px;
    `
    : `
  border: 1px solid #cbcbcb;
  width: ${width || '277px'};
  background-size: 13px 13px;
    `
  )}
  
  ${({ isLoading }) => isLoading
    && css`
      opacity: 0.5;
      cursor: not-allowed;
    `}

  &:focus,
  &:active {
    outline: none;
    border: 1px solid #F08E31;
    width: ${({ width }) => width || '277px'};
    background-size: 13px 13px;
  }
  ::-webkit-input-placeholder {
    font-family: 'Roboto', sans-serif;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    /* identical to box height */

    color: #e2d5d5;
  }
`;
